// extracted by mini-css-extract-plugin
export var fullGrid = "_2n-3";
export var pdpPreviewContainer = "_2n-1";
export var previewContainer = "_2n-0";
export var togglePreviewContainer = "_2n-2";